export const importFileValidationConfig = {
  requireValueInAllColumns: false,
  // Columnas que deben existir en el fichero, aunque alguna celda pueda venir vacia.
  requiredColumns: [
    "G/L Account",
    "Profit Center",
    "Cost Center",
    "WBS Element External ID",
    "Fiscal Year Period",
    "Amount in Company Code Currency",
    "Amount in Transaction Currency",
    "Journal Entry Type",
    "Journal Entry",
    "Journal Entry Item Text",
    "Trading Partner",
    "Invoice Reference",
    "Journal Entry Date",
    "Debit/Credit Code",
    "Clearing Date",
    "Net Due Date",
    "Company Code Currency",
    "Assignment Reference",
    "Company Code",
    "Posting Date",
    "Tax Code",
    "Clearing Journal Entry",
  ],
  columnRules: {
    "G/L Account": {
      required: true,
      // Formato: codigo + descripcion entre parentesis. Ej: 16210000 (Clearing account others)
      pattern: /^\d+\s*\(.+\)$/,
    },
    "Profit Center": {
      required: true,
      // Formato: codigo (longitud variable, puede empezar por letra) + descripcion entre parentesis. Ej: A1000300010 (Valladolid HFB)
      pattern: /^[A-Za-z]?\d+\s*\(.+\)$/,
    },
    "Fiscal Year Period": {
      required: true,
      // Formato periodo contable MMM.AAAA. Ej: 008.2026
      pattern: /^\d{3}\.\d{4}$/,
    },
    "Amount in Company Code Currency": {
      required: true,
      // Formato importe + moneda (3 letras). Acepta: 99.00 EUR, 99,00 EUR, 3,553.15 EUR, - 5.98 EUR
      pattern: /^-?\s*(?:\d+|\d{1,3}(?:,\d{3})+)(?:[.,]\d{2})\s+[A-Z]{3}$/,
    },
    "Amount in Transaction Currency": {
      required: true,
      // Formato importe + moneda (3 letras). Acepta: 99.00 EUR, 99,00 EUR, 3,553.15 EUR, - 5.98 EUR
      pattern: /^-?\s*(?:\d+|\d{1,3}(?:,\d{3})+)(?:[.,]\d{2})\s+[A-Z]{3}$/,
    },
    "Journal Entry Type": {
      required: true,
    },
    "Journal Entry": {
      required: true,
      // Solo numeros para el identificador del asiento.
      pattern: /^\d+$/,
    },
    "Journal Entry Item Text": {
      required: false,
    },
    "Journal Entry Date": {
      required: true,
      // Fecha en formato DD.MM.AAAA. Ej: 02.04.2026
      pattern: /^\d{2}\.\d{2}\.\d{4}$/,
    },
    "Debit/Credit Code": {
      required: true,
      allowedValues: ["S (Debit)", "H (Credit)"],
    },
    "Company Code Currency": {
      required: true,
      // Codigo ISO de moneda en 3 letras mayusculas. Ej: EUR
      pattern: /^[A-Z]{3}$/,
    },
    "Assignment Reference": {
      required: true,
      // Debe tener exactamente 8 digitos numericos.
      pattern: /^\d{8}$/,
    },
    "Company Code": {
      required: true,
      // Formato: codigo + descripcion entre parentesis. Ej: 2600 (IKEA Iberica S.A.)
      pattern: /^\d+\s*\(.+\)$/,
    },
    "Posting Date": {
      required: true,
      // Fecha en formato DD.MM.AAAA. Ej: 30.04.2026
      pattern: /^\d{2}\.\d{2}\.\d{4}$/,
    },
  },
};